import React from "react";
import "../Delete/DeleteGroup.css";
import "../SucessGroup/DeleteGroupSucesFully.css";

export default function SuceesMemberDeleteMsg({ change, setMember }) {
  return (
    <div>
      <div className="deleteGroupAll_sucessFUlly ">
        <div className="delete_success_container col-md-5 col-10 ">
          <div className="d-flex">
            <img
              className="group_profile_img "
              alt=""
              src="/group-img/GroupSuccess.svg"
            ></img>
          </div>
          <div className="group_delete_sucessFullyMsg ">
            Member deleted successfully!
          </div>
          <button
            onClick={(e) => {
              change(false);
              setMember(false);
            }}
            className="okay_btn_group"
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
